import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const basePath = '/dnfministry';

  return (
    <footer style={{ backgroundColor: '#1a1a1a', borderTop: '1px solid rgba(184,134,11,0.2)' }}>
      {/* Main Footer */}
      <div style={{ maxWidth: '80rem', margin: '0 auto', padding: '4rem 1rem' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '3rem' }}>
          {/* Brand Column */}
          <div style={{ gridColumn: 'span 2' }}>
            <h3 className="font-script" style={{ fontSize: '2rem', color: '#B8860B', marginBottom: '0.5rem' }}>
              Drip N Fiyah
            </h3>
            <p style={{ fontSize: '0.65rem', letterSpacing: '0.3em', color: 'rgba(245,245,220,0.6)', textTransform: 'uppercase', marginBottom: '1.5rem' }}>
              Ministry
            </p>
            <p style={{ color: 'rgba(245,245,220,0.7)', lineHeight: 1.7, marginBottom: '1.5rem' }}>
              Officiating sacred unions with grace, dignity, and the eternal flame of love.
              Every ceremony is crafted to honor your unique journey together.
            </p>
            <div className="scripture-quote" style={{ fontSize: '0.875rem' }}>
              "...He considered me faithful by assigning me to a ministry."
              <span style={{ display: 'block', marginTop: '0.5rem', color: 'rgba(184,134,11,0.8)' }}>— 1 Timothy 1:12</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif" style={{ fontSize: '1.125rem', color: '#B8860B', marginBottom: '1.5rem' }}>Quick Links</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {[
                { name: 'About', path: `${basePath}/about` },
                { name: 'Services', path: `${basePath}/services` },
                { name: 'Gallery', path: `${basePath}/gallery` },
                { name: 'FAQ', path: `${basePath}/faq` },
                { name: 'Book Now', path: `${basePath}/booking` },
              ].map((link) => (
                <li key={link.name} style={{ marginBottom: '0.75rem' }}>
                  <Link
                    to={link.path}
                    style={{ color: 'rgba(245,245,220,0.7)', textDecoration: 'none', fontSize: '0.875rem', transition: 'color 0.3s' }}
                    onMouseOver={(e) => e.target.style.color = '#d4a828'}
                    onMouseOut={(e) => e.target.style.color = 'rgba(245,245,220,0.7)'}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-serif" style={{ fontSize: '1.125rem', color: '#B8860B', marginBottom: '1.5rem' }}>Contact</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', marginBottom: '1rem' }}>
                <Mail style={{ width: '1.25rem', height: '1.25rem', color: '#B8860B', marginTop: '0.125rem' }} />
                <span style={{ color: 'rgba(245,245,220,0.7)', fontSize: '0.875rem' }}>
                  contact@dnfministry.com
                </span>
              </li>
              <li style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', marginBottom: '1rem' }}>
                <Phone style={{ width: '1.25rem', height: '1.25rem', color: '#B8860B', marginTop: '0.125rem' }} />
                <span style={{ color: 'rgba(245,245,220,0.7)', fontSize: '0.875rem' }}>
                  Available upon request
                </span>
              </li>
              <li style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                <MapPin style={{ width: '1.25rem', height: '1.25rem', color: '#B8860B', marginTop: '0.125rem' }} />
                <span style={{ color: 'rgba(245,245,220,0.7)', fontSize: '0.875rem' }}>
                  Available for travel
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div style={{ borderTop: '1px solid rgba(184,134,11,0.1)' }}>
        <div style={{ maxWidth: '80rem', margin: '0 auto', padding: '1.5rem 1rem' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: '1rem' }}>
            <p style={{ color: 'rgba(245,245,220,0.5)', fontSize: '0.875rem', display: 'flex', alignItems: 'center' }}>
              © {currentYear} Drip N Fiyah Ministry. Made with{' '}
              <Heart style={{ width: '1rem', height: '1rem', color: '#B8860B', margin: '0 0.25rem', fill: '#B8860B' }} />{' '}
              for sacred unions.
            </p>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
              <Link
                to={`${basePath}/privacy`}
                style={{ color: 'rgba(245,245,220,0.5)', textDecoration: 'none', fontSize: '0.875rem' }}
              >
                Privacy Policy
              </Link>
              <Link
                to={`${basePath}/terms`}
                style={{ color: 'rgba(245,245,220,0.5)', textDecoration: 'none', fontSize: '0.875rem' }}
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
